module.exports = __webpack_public_path__ + "static/media/maybach-go-drive.8b1e3de9.png";